__turbopack_context__.v({
  "contactContentGridItem": "Contact-shared-module-scss-module__oDzpaq__contactContentGridItem",
  "contactContentStack": "Contact-shared-module-scss-module__oDzpaq__contactContentStack",
  "contactRootGrid": "Contact-shared-module-scss-module__oDzpaq__contactRootGrid",
  "contactSpecialOpeningHours": "Contact-shared-module-scss-module__oDzpaq__contactSpecialOpeningHours",
});
